export const BULK_TAGS_REQUEST = "BULK_TAGS_REQUEST";
export const BULK_TAGS_RESULT = "BULK_TAGS_RESULT";
export const BULK_TAGS_OPEN_MODAL = "BULK_TAGS_OPEN_MODAL";
export const BULK_TAGS_CLOSE_MODAL = "BULK_TAGS_CLOSE_MODAL";
export const BULK_TAGS_GET_DEVICE_REQUEST = "BULK_TAGS_GET_DEVICE_REQUEST";
export const BULK_TAGS_GET_DEVICE_RESULT = "BULK_TAGS_GET_DEVICE_RESULT";

export const BULK_TAGS_SET_DEVICE = "BULK_TAGS_SET_DEVICE";

